import { FC } from "react";
import { useOverlays } from "contexts/OverlayContext";
import { LegacyPlusEntityLimitModal } from "./LegacyPlusEntityLimitModal";

export const LegacyPlusEntityLimitModalContainer: FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    if (!getOverlayInfo("legacyPlusEntityLimit")) {
        return null;
    }

    return (
        <LegacyPlusEntityLimitModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
        />
    );
};
